export const listAllPersonas = `
  query adminListPersonas($filter: PersonasFilterInput, $limit: Int, $nextToken: String) {
    adminListPersonas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        givenName
        familyName
        email
        status
        createdByUsername
        created
        updated
      }
      nextToken
    }
  }
`;

export const listAllAliases = `
  query adminListAliases($filter: AliasesFilterInput, $limit: Int, $nextToken: String) {
    adminListAliases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        aliasType
        aliasStatus
        createdFromPersona
        createdByUsername
        created
        updated
      }
      nextToken
    }
  }
`;

export const listAllTags = `
  query adminListTags($filter: TagsFilterInput, $limit: Int, $nextToken: String) {
    adminListTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        createdByUsername
        created
        updated
      }
      nextToken
    }
  }
`;

export const listAllMessages = `
  query adminListMessages($filter: MessagesFilterInput, $limit: Int, $nextToken: String) {
    adminListMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subject
        from
        to
        status
        createdByUsername
        created
        updated
      }
      nextToken
    }
  }
`;

export const listAllContacts = `
  query adminListContacts($filter: ContactsFilterInput, $limit: Int, $nextToken: String) {
    adminListContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        givenName
        familyName
        email
        createdByUsername
        created
        updated
      }
      nextToken
    }
  }
`;
